const STAGING_HOST = 'greenlight-staging.ivn-works.com';
const PROD_HOST    = 'greenlight.ivn-works.com';

export type Env = 'staging' | 'production' | 'local';

export interface EnvOption {
  env: Exclude<Env, 'local'>;
  /** Operator-facing name. Staging is presented as "Sandbox" (BOT-392) — that
   *  is the word the business uses for "the copy where mistakes are cheap". */
  label: string;
  hint: string;
  href: (path: string) => string;
}

export const ENV_OPTIONS: EnvOption[] = [
  {
    env: 'production',
    label: 'Production',
    hint: 'Live NetSuite & Magento data',
    href: path => `https://${PROD_HOST}${path}`,
  },
  {
    env: 'staging',
    label: 'Sandbox',
    hint: 'Staging deployment — safe to experiment',
    href: path => `https://${STAGING_HOST}${path}`,
  },
];

export function useEnvironment() {
  const host = window.location.hostname;
  const env: Env =
    host === STAGING_HOST ? 'staging' :
    host === PROD_HOST    ? 'production' :
    'local';
  const isStaging = env === 'staging';

  /** Operator-facing name of the current environment. */
  const label = env === 'staging' ? 'Sandbox' : env === 'production' ? 'Production' : 'Local';

  function otherEnvHref(path: string): string {
    return isStaging
      ? `https://${PROD_HOST}${path}`
      : `https://${STAGING_HOST}${path}`;
  }

  return { env, isStaging, label, otherEnvHref };
}
